import React from "react";
import { Button, Paper, TextField, MenuItem } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";

export const DefaultFilter = {
  keyword: "",
  categoryId: "",
  statusId: "",
  investmentTypeId: "",
  investorId: "",
  isActive: "",
  isFeatured: "",
  minArea: "",
  maxArea: "",
};

const masterLabel = (item) => item.name + (item.isActive ? "" : " (ngừng)");

const SelectField = ({ label, value, onChange, options, getLabel }) => (
  <TextField
    select
    fullWidth
    size="small"
    variant="outlined"
    label={label}
    value={value}
    onChange={onChange}
  >
    <MenuItem value="">Tất cả</MenuItem>
    {options.map((item) => (
      <MenuItem key={item.id} value={String(item.id)}>
        {getLabel(item)}
      </MenuItem>
    ))}
  </TextField>
);

const BoolOptions = (trueLabel, falseLabel) => [
  { id: "true", name: trueLabel, isActive: true },
  { id: "false", name: falseLabel, isActive: true },
];

const SearchInvestmentProject = ({ filter, setFilter, onSearch, onReset, lookups }) => {
  const { categories, statuses, types, investors } = lookups;

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setFilter((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch();
  };

  const selectedInvestor =
    investors.find((item) => String(item.id) === String(filter.investorId)) || null;

  return (
    <Paper className="p-3 mb-3">
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="row">
          <div className="col-md-6 col-lg-4 mb-3">
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Từ khoá (tên hoặc mã dự án)"
              value={filter.keyword}
              onChange={handleChange("keyword")}
            />
          </div>
          <div className="col-md-6 col-lg-4 mb-3">
            <SelectField
              label="Danh mục"
              value={filter.categoryId}
              onChange={handleChange("categoryId")}
              options={categories}
              getLabel={masterLabel}
            />
          </div>
          <div className="col-md-6 col-lg-4 mb-3">
            <SelectField
              label="Trạng thái dự án"
              value={filter.statusId}
              onChange={handleChange("statusId")}
              options={statuses}
              getLabel={masterLabel}
            />
          </div>
          <div className="col-md-6 col-lg-4 mb-3">
            <SelectField
              label="Hình thức đầu tư"
              value={filter.investmentTypeId}
              onChange={handleChange("investmentTypeId")}
              options={types}
              getLabel={masterLabel}
            />
          </div>
          <div className="col-md-6 col-lg-4 mb-3">
            <Autocomplete
              options={investors}
              getOptionLabel={(option) => option.name || ""}
              value={selectedInvestor}
              onChange={(event, newValue) =>
                setFilter((prev) => ({
                  ...prev,
                  investorId: newValue ? String(newValue.id) : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Chủ đầu tư"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </div>
          <div className="col-md-3 col-lg-2 mb-3">
            <SelectField
              label="Hiển thị"
              value={filter.isActive}
              onChange={handleChange("isActive")}
              options={BoolOptions("Đang hiển thị", "Đang ẩn")}
              getLabel={(item) => item.name}
            />
          </div>
          <div className="col-md-3 col-lg-2 mb-3">
            <SelectField
              label="Nổi bật"
              value={filter.isFeatured}
              onChange={handleChange("isFeatured")}
              options={BoolOptions("Nổi bật", "Không nổi bật")}
              getLabel={(item) => item.name}
            />
          </div>
          <div className="col-md-3 col-lg-2 mb-3">
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              label="Diện tích từ"
              value={filter.minArea}
              onChange={handleChange("minArea")}
              inputProps={{ min: 0 }}
            />
          </div>
          <div className="col-md-3 col-lg-2 mb-3">
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              label="Diện tích đến"
              value={filter.maxArea}
              onChange={handleChange("maxArea")}
              inputProps={{ min: 0 }}
            />
          </div>
          <div className="col-lg-4 mb-3 d-flex align-items-start justify-content-end">
            <Button
              type="button"
              variant="contained"
              className="mr-2"
              startIcon={<ClearIcon />}
              onClick={onReset}
            >
              Xoá lọc
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              startIcon={<SearchIcon />}
            >
              Tìm kiếm
            </Button>
          </div>
        </div>
      </form>
    </Paper>
  );
};

export default SearchInvestmentProject;
